import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import { ILayerProps, ITextLayerProps, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { findFontLostAndReplace } from '@/utils/layer';

export const adjustFontFamily = (allLayers: ILayerProps[], fonts: any[]) => {
    traverseTrees(
        // clientTemplate.templateConf.layers,
        allLayers,
        (currentLayer: ILayerProps) => {
            if (currentLayer.layerType === LayerType.TEXT_LAYER) {
                const textData = currentLayer.data as ITextLayerProps;

                findFontLostAndReplace(textData, fonts);
            }

            // =========   isExtraGroup  临时成组需要这个字段
            if (currentLayer.layerType === LayerType.GROUP_LAYER) {
                currentLayer.data = { isExtraGroup: false };
            }
        },
    );
};
